"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "arrowColors", {
  enumerable: true,
  get: function get() {
    return _Arrow.arrowColors;
  }
});
Object.defineProperty(exports, "placements", {
  enumerable: true,
  get: function get() {
    return _constants.placements;
  }
});
exports.default = void 0;

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactPopper = require("react-popper");

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _assignRef = _interopRequireDefault(require("../../utils/assignRef"));

var _useClickOutside = _interopRequireDefault(require("../../utils/useClickOutside"));

var _usePrevious = _interopRequireDefault(require("../../utils/usePrevious"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _ConfigProvider = require("../../providers/ConfigProvider");

var _Arrow = _interopRequireWildcard(require("./Arrow"));

var _Content = _interopRequireWildcard(require("./Content"));

var _constants = require("./constants");

var _types = require("./types");

var _utils = require("./utils");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var modifiers = {
  preventOverflow: {
    boundariesElement: 'viewport'
  }
};
/**
 * TODO
 * - Improve accessibility metadata
 * - Focus first "focusable" element inside the popover when shown
 */

var Popover = function Popover(props, instanceRef) {
  var alwaysRender = props.alwaysRender,
      arrowColor = props.arrowColor,
      borderRadius = props.borderRadius,
      children = props.children,
      containerSelector = props.containerSelector,
      _props$contentRole = props.contentRole,
      contentRole = _props$contentRole === void 0 ? 'dialog' : _props$contentRole,
      defaultVisible = props.defaultVisible,
      enabled = props.enabled,
      _props$hideOnClickOut = props.hideOnClickOutside,
      hideOnClickOutside = _props$hideOnClickOut === void 0 ? true : _props$hideOnClickOut,
      _props$hideOnESC = props.hideOnESC,
      hideOnESC = _props$hideOnESC === void 0 ? true : _props$hideOnESC,
      id = props.id,
      manageEvents = props.manageEvents,
      onHide = props.onHide,
      onRequestHide = props.onRequestHide,
      onShow = props.onShow,
      placement = props.placement,
      _props$showArrow = props.showArrow,
      showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
      target = props.target,
      visible = props.visible,
      zIndex = props.zIndex,
      rest = _objectWithoutProperties(props, ["alwaysRender", "arrowColor", "borderRadius", "children", "containerSelector", "contentRole", "defaultVisible", "enabled", "hideOnClickOutside", "hideOnESC", "id", "manageEvents", "onHide", "onRequestHide", "onShow", "placement", "showArrow", "target", "visible", "zIndex"]);

  var contentRef = (0, _react.useRef)(null);
  var internalNodeRef = (0, _react.useRef)(null);
  var previousContent = (0, _usePrevious.default)(children);
  var scheduleUpdateRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(!!visible || !!defaultVisible),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useConfig = (0, _ConfigProvider.useConfig)(),
      createPortal = _useConfig.createPortal; // wrapper for setting visibility state; forces a recalculation
  // of the popper position (computing new offsets) each time the
  // popover window becomes visible


  var setIsVisible = (0, _react.useCallback)(function (makeItVisible) {
    setIsVisibleState(makeItVisible);

    if (makeItVisible && scheduleUpdateRef.current) {
      scheduleUpdateRef.current();
    }

    if (!makeItVisible) {
      (0, _assignRef.default)(scheduleUpdateRef, null);
    }
  }, [setIsVisibleState]);
  var uuid = (0, _useUniqueId.default)(id, 'popover-');
  var show = (0, _react.useCallback)(function (event) {
    if (visible === undefined) {
      onShow && onShow(event);
      setIsVisible(true);
    }
  }, [visible, setIsVisible, onShow]);
  var hide = (0, _react.useCallback)(function (event) {
    if (isVisible) {
      if (visible === undefined) {
        onHide && onHide(event);
        setIsVisible(false);
      } else {
        onRequestHide && onRequestHide();
      }
    }
  }, [isVisible, visible, setIsVisible, onHide, onRequestHide]);
  var toggle = (0, _react.useCallback)(function (event) {
    isVisible ? hide(event) : show(event);
  }, [isVisible, show, hide]);
  var onKeyDown = (0, _react.useCallback)(function (e) {
    if (hideOnESC && isVisible && e.key === 'Escape') {
      hide();
    }
  }, [hideOnESC, isVisible, hide]);
  var onClickOutside = (0, _react.useCallback)(function () {
    if (hideOnClickOutside && isVisible) {
      hide();
    }
  }, [hideOnClickOutside, isVisible, hide]);

  var _useTarget = (0, _utils.useTarget)(_objectSpread({}, props, {
    internalNodeRef: internalNodeRef,
    actions: {
      show: show,
      hide: hide,
      toggle: toggle
    }
  })),
      _useTarget2 = _slicedToArray(_useTarget, 2),
      targetNode = _useTarget2[0],
      targetType = _useTarget2[1];

  var ariaAttributes = (0, _react.useMemo)(function () {
    return {
      'aria-haspopup': contentRole,
      'aria-expanded': isVisible,
      'aria-controls': isVisible ? uuid : ''
    };
  }, [isVisible, uuid, contentRole]);
  (0, _useClickOutside.default)([contentRef, internalNodeRef, targetNode], onClickOutside, {
    // We use the capture phase because we want to check for outside
    // clicks any show/hide triggers being called on the same event.
    capture: true
  }); // Expose the visibility actions as an instance API

  (0, _react.useEffect)(function () {
    (0, _assignRef.default)(instanceRef, {
      ariaAttributes: ariaAttributes,
      hide: hide,
      isVisible: isVisible,
      show: show,
      toggle: toggle,
      targetNode: targetNode,
      contentNode: contentRef.current
    });
  }, [instanceRef, ariaAttributes, hide, isVisible, show, toggle, targetNode, contentRef && contentRef.current]); // React to changes to the `visible` prop if we are a controlled component

  (0, _react.useEffect)(function () {
    return setIsVisible(visible !== undefined ? visible : isVisible);
  }, [visible, isVisible, setIsVisible]); // Allow closing the popover by pressing the Escape key

  (0, _react.useEffect)(function () {
    /* istanbul ignore else */
    if (_canUseDOM.default) {
      document.addEventListener('keydown', onKeyDown);
      return function () {
        document.removeEventListener('keydown', onKeyDown);
      };
    }
    /* istanbul ignore next didn't test a non DOM env */


    return undefined;
  }, [isVisible, onKeyDown]); // Reposition popper if the content changes:
  // https://github.com/FezVrasta/react-popper/issues/283

  (0, _react.useEffect)(function () {
    if (previousContent !== children && scheduleUpdateRef.current) {
      scheduleUpdateRef.current();
    }
  }, [previousContent, children]);

  if (!target) {
    return null;
  }

  var popper = _react.default.createElement(_reactPopper.Popper, {
    modifiers: modifiers,
    placement:
    /* istanbul ignore next */
    placement || 'bottom',
    referenceElement: targetNode || undefined
  }, function (_ref) {
    var arrowProps = _ref.arrowProps,
        p = _ref.placement,
        scheduleUpdate = _ref.scheduleUpdate,
        other = _objectWithoutProperties(_ref, ["arrowProps", "placement", "scheduleUpdate"]);

    if (!scheduleUpdateRef.current) {
      (0, _assignRef.default)(scheduleUpdateRef, (0, _throttle.default)(scheduleUpdate, 500));
    }

    return _react.default.createElement(_Content.default, _extends({}, other, {
      hasArrow: showArrow,
      placement: p,
      zIndex: zIndex
    }), _react.default.createElement(_Arrow.default, _extends({}, arrowProps, {
      "aria-hidden": true,
      color: arrowColor,
      hidden: !showArrow,
      placement: p
    })), _react.default.createElement(_Content.ContentInner, _extends({}, rest, {
      borderRadius: borderRadius,
      id: uuid,
      ref: contentRef,
      role: contentRole,
      "aria-hidden": !isVisible
    }), typeof children === 'function' ? children({
      hide: hide
    }) : children));
  });

  return _react.default.createElement(_reactPopper.Manager, null, targetType === _types.TargetType.RenderProp && _react.default.createElement(_reactPopper.Reference, null, function (_ref2) {
    var ref = _ref2.ref;

    var renderPropRef = function renderPropRef(node) {
      ref(node);
      (0, _assignRef.default)(internalNodeRef, node);
    };

    var data = {
      ref: renderPropRef,
      hide: hide,
      show: show,
      toggle: toggle,
      isVisible: isVisible,
      ariaAttributes: ariaAttributes
    };
    return target(data);
  }), targetType === _types.TargetType.Element && (0, _react.cloneElement)(target, _objectSpread({
    ref: internalNodeRef
  }, ariaAttributes)), enabled && (alwaysRender || isVisible) && (containerSelector === 'parent' ?
  /* istanbul ignore next */
  popper : createPortal(popper, containerSelector)));
};

var PopoverWithRef = (0, _react.forwardRef)(Popover); // @ts-ignore

PopoverWithRef.propTypes = {
  id: _propTypes.default.string,
  enabled: _propTypes.default.bool,
  onShow: _propTypes.default.func,
  onHide: _propTypes.default.func,
  target: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(
    /* istanbul ignore next didn't test a non DOM env */
    // @ts-ignore
    _canUseDOM.default ? Element : function Element() {})
  })]).isRequired,
  alwaysRender: _propTypes.default.bool,
  visible: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.func]).isRequired,
  placement: _propTypes.default.oneOf(_constants.placements),
  showArrow: _propTypes.default.bool,
  arrowColor: _propTypes.default.oneOf(Object.keys(_Arrow.arrowColors)),
  manageEvents: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['click', 'hover'])]),
  hideOnESC: _propTypes.default.bool,
  hideOnClickOutside: _propTypes.default.bool,
  onRequestHide: _propTypes.default.func,
  defaultVisible: _propTypes.default.bool,
  containerSelector: _propTypes.default.string,
  zIndex: _propTypes.default.number
};
PopoverWithRef.defaultProps = {
  alwaysRender: false,
  enabled: true,
  showArrow: true,
  placement: 'bottom'
};
PopoverWithRef.displayName = 'Popover';
var _default = PopoverWithRef;
exports.default = _default;